import { AppState } from '../rootReducer';

export const getDeclineTrendsFilter = (state: AppState) => state.declineTrends.filter || [];
